<template>
  <div>
    <!--    First Version Caspian-->
    <transition
      name="animate__fadeIn"
      enter-active-class="animate__animated animate__fadeIn"
      leave-active-class="animate__animated animate__fadeOut"
      appear
    >
      <b-row v-if="getVersion === 'v1'">
        <b-col lg="7" class="d-none d-lg-block mt-10">
          <b-container>
            <img src="@/assets/images/background1.png" width="100%" />
          </b-container>
          <b-col cols="12">
            <b-container class="mt-10">
              <h1 class="text-center font-size-xl pb-3">
                {{ $translate("accountToAccountGateway") }}
              </h1>
              <p class="font-size-large text-center dodger-blue-text">
                {{ $translate("enterPayingAmountAndAccountNumber") }}
              </p>
            </b-container>
          </b-col>
        </b-col>
        <b-col cols="12" lg="5">
          <shetab-stepper class="shetabStepper"></shetab-stepper>
          <!-- <transition
            name="animate__fadeIn"
            enter-active-class="animate__animated animate__fadeIn"
            appear
          > -->
          <b-container
            v-if="getStepperPage === 'pageOne'"
            class="background-secondary border-radius-10px border-light-gray-1px my-3 py-5 position-relative"
          >
            <button
              class="position-absolute back-button-position back-button"
              @click="goPageBack()"
            >
              {{ $translate("back") }}
            </button>
            <b-row class="d-flex justify-content-center align-items-center">
              <b-col
                v-for="(account, index) in offlineAccountList"
                :key="index"
                cols="4"
                class="d-flex justify-content-center align-items-center"
              >
                <button
                  class="d-flex flex-column background-transparent border-none align-items-center justify-content-center"
                  @click="selectAccount(account, 'pageTwo')"
                >
                  <img
                    class="ordinary-img"
                    :src="handleOfflineAccountBankLogo(account)"
                    :class="{
                      'mix-blend-mode-luminosity': false,
                    }"
                    height="80"
                    width="80"
                  />
                  <p class="mt-2 font-size-medium-small font-weight-bold">
                    {{ handleOfflineAccountBankName(account) }}
                  </p>
                </button>
              </b-col>
              <b-col
                cols="12"
                class="d-flex justify-content-center align-items-center mt-5 pt-5"
              >
                <span
                  class="cornflower-blue-text font-size-large font-weight-bold text-center"
                >
                  {{ $translate("accountToAccountBankSelect") }}
                </span>
              </b-col>
              <b-col
                cols="4"
                class="d-flex justify-content-center align-items-center pt-3"
              >
                <button
                  type="button"
                  class="decline-button"
                  @click="cancelPayment"
                >
                  {{ $translate("cancel") }}
                </button>
              </b-col>
            </b-row>
          </b-container>
          <!-- </transition> -->
          <!--        First Container for (Tether) Notice-->
          <transition
            name="animate__fadeIn"
            enter-active-class="animate__animated animate__fadeIn"
            appear
          >
            <b-container
              v-if="getStepperPage === 'pageTwo'"
              class="background-secondary border-radius-10px border-light-gray-1px my-3 pt-3"
            >
              <b-col class="flex-center title-text font-size-large pb-5">
                <span>{{ $translate("attention") }}!!!</span>
              </b-col>
              <!--          75% Padding is for making this page's height as equal as shetabs-->
              <b-col
                class="steel-blue-text font-size-medium font-weight-bold pb-10"
              >
                <p v-html="$translate('accountToAccountInfo')"></p>
                <br />
                <p v-html="$translate('accountToAccountAlert')"></p>
              </b-col>
              <b-col class="flex-center pb-3">
                <button
                  type="button"
                  class="go-to-next-button"
                  @click="getCardNumber()"
                >
                  <b-row class="fill-width">
                    <b-col cols="10">{{
                      $translate("showAccountNumber")
                    }}</b-col>
                    <b-col cols="2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="currentColor"
                        class="bi bi-arrow-left-short"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
                        />
                      </svg>
                    </b-col>
                  </b-row>
                </button>
              </b-col>
              <b-col class="flex-center pb-3" @click="openVideoPlayer()">
                <button
                  type="button"
                  class="go-to-next-button background-info-primary font-weight-bold"
                >
                  <span class="info-secondary-text">
                    {{ $translate("helper") }}
                  </span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-info-circle info-secondary-text"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                    />
                    <path
                      d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                    />
                  </svg>
                </button>
              </b-col>
            </b-container>
          </transition>
          <!--        /First Container for (CardToCard) Notice-->

          <!--        Second Container for (CardToCard) Show Wallet and Payment Information-->

          <b-col
            class="steel-blue-text font-size-medium flex-center"
            v-if="getStepperPage === 'pageThree'"
          >
            <span class="mb-0 dodger-blue-text font-weight-bold">
              {{ $translate("enterPayingAmountAndAccountNumber") }}
            </span>
          </b-col>
          <transition
            name="animate__fadeIn"
            enter-active-class="animate__animated animate__fadeIn"
            appear
          >
            <b-container
              v-if="getStepperPage === 'pageThree'"
              id="showWalletPageSecond"
              class="my-3"
            >
              <b-col class="flex-center midnight-blue-text pb-3">
                <img
                  :src="handleCardImage(selectedAccount)"
                  class="fill-width position-relative"
                />
                <div class="image-card-details">
                  <b-row no-gutters class="flex-center">
                    <b-col
                      cols="8"
                      class="flex-center direction-ltr font-size-xl"
                    >
                      {{ receiverCreditCardNumber }}
                      <!--                      <button
                        @click.stop.prevent="copyToClipboard"
                        class="border-none background-transparent"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          fill="currentColor"
                          v-if="!copyToClipboardResult"
                          class="bi bi-clipboard-data"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M4 11a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0v-1zm6-4a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V7zM7 9a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0V9z"
                          />
                          <path
                            d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
                          />
                          <path
                            d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"
                          />
                        </svg>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          fill="currentColor"
                          v-if="copyToClipboardResult"
                          class="bi bi-clipboard-check"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                          />
                          <path
                            d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
                          />
                          <path
                            d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"
                          />
                        </svg>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          fill="currentColor"
                          v-if="copyToClipboardFailed"
                          class="bi bi-clipboard-x"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M6.146 7.146a.5.5 0 0 1 .708 0L8 8.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 9l1.147 1.146a.5.5 0 0 1-.708.708L8 9.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 9 6.146 7.854a.5.5 0 0 1 0-.708z"
                          />
                          <path
                            d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
                          />
                          <path
                            d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"
                          />
                        </svg>
                      </button>-->
                      <!-- <input
                        class="receiver-card-number-input border-none background-transparent direction-ltr font-size-large"
                        type="text"
                        id="receiverCreditCardNumber"
                        v-model="receiverCreditCardNumber"
                        readonly
                      /> -->
                    </b-col>
                    <b-col
                      cols="12"
                      class="pt-1 d-flex justify-content-center align-items-center card-owner-name-text"
                    >
                      {{ receiverName }}
                    </b-col>
                  </b-row>
                </div>
              </b-col>
              <b-row class="d-flex align-items-center mb-3">
                <b-col
                  cols="7"
                  class="midnight-blue-text font-size-small pb-1 font-weight-bold"
                >
                  <span> {{ $translate("accountNumber") }}: </span>
                </b-col>
                <!--                read only input-->
                <!-- <b-row
                  no-gutters
                  class="direction-ltr m-0 p-0"
                  v-if="isCreditCardReceivedFromServer"
                >
                  <b-col cols="12">
                    <div class="input-group p-0">
                      <div class="input-group-prepend" v-if="bankImageSource">
                        <span class="input-group-text fill-height">
                          <img
                            :src="bankImageSource"
                            height="25"
                            width="25"
                            v-if="checkIfInputNotEmpty"
                          />
                        </span>
                      </div>
                      <input
                        v-for="(key, i) in creditCardInfo"
                        :value="creditCardInfo[i].value"
                        :key="i"
                        readonly
                        class="col-2 form-control mx-1"
                      />
                    </div>
                  </b-col>
                </b-row> -->

                <!-- v-if="!isCreditCardReceivedFromServer" -->
                <b-row no-gutters class="direction-ltr m-0 p-0">
                  <b-col cols="12">
                    <div class="input-group p-0">
                      <!-- <div class="input-group-prepend" v-if="bankImageSource">
                        <span class="input-group-text fill-height">
                          <img
                            :src="bankImageSource"
                            height="25"
                            width="25"
                            v-if="checkIfInputNotEmpty"
                          />
                        </span>
                      </div> -->
                      <input
                        required
                        @paste="onCreditCardPaste($event, 'creditCardInfo')"
                        v-model="accountInfo"
                        class="col-10 form-control mx-1"
                        :placeholder="accountPlaceholder"
                        v-mask="accountMask"
                        mask="false"
                      />
                    </div>
                  </b-col>
                  <!-- <transition
                    name="animate__fadeIn"
                    :duration="200"
                    enter-active-class="animate__animated animate__fadeIn "
                    leave-active-class="animate__animated animate__fadeOut "
                    appear
                  >
                    <b-col
                      cols="12"
                      class="d-flex justify-content-end align-items-center pt-3"
                      v-if="
                        !secondContainerVisibility &&
                        creditCardInfo[3].value.length === 4
                      "
                    >
                      <span
                        class="light-red-text font-size-xs font-weight-bold"
                      >
                        {{ $translate("invalidCardNumber") }}
                      </span>
                    </b-col>
                  </transition> -->
                </b-row>
              </b-row>

              <b-row class="d-flex align-items-center">
                <b-col
                  cols="5"
                  class="midnight-blue-text font-size-small pb-1 font-weight-bold"
                >
                  <span>
                    {{ $translate("payingAmount") }} ({{
                      $translate("toman")
                    }}):
                  </span>
                </b-col>
                <b-col
                  cols="7"
                  class="padding-left-20px"
                  v-if="
                    !isShetabAmountsReceivedFromServer && !shetabOfflineAmounts
                  "
                >
                  <input
                    class="form-control mx-1"
                    v-mask="'##################'"
                    mask="false"
                    v-model="amountValue"
                  />
                </b-col>
                <b-col
                  cols="7"
                  class="padding-left-20px"
                  v-if="isShetabAmountsReceivedFromServer"
                >
                  <input
                    class="form-control mx-1"
                    v-mask="'###################'"
                    mask="false"
                    readonly
                    v-model="amountValue"
                  />
                </b-col>
                <b-col
                  cols="7"
                  class="padding-left-20px"
                  v-if="
                    !isShetabAmountsReceivedFromServer && shetabOfflineAmounts
                  "
                >
                  <b-form-select
                    class="form-control"
                    v-model="amountValue"
                    :options="shetabOfflineAmounts"
                    required
                  ></b-form-select>
                </b-col>
              </b-row>
              <b-row class="flex-vertical-align pt-4">
                <b-col cols="4"> {{ $translate("securityCode") }}:</b-col>
                <b-col cols="6">
                  <b-input
                    class="direction-ltr"
                    id="captchaInput"
                    v-mask="'####'"
                    mask="false"
                    v-model="captchaInput"
                    :class="{ secondVersionInputs: getVersion === 'v2' }"
                  ></b-input>
                </b-col>
              </b-row>
              <b-row class="flex-vertical-align my-4">
                <b-col cols="10" class="d-flex justify-content-end">
                  <!--Captcha Image-->
                  <b-spinner
                    variant="primary"
                    v-if="getCaptchaImagePending"
                    class="mx-5"
                  ></b-spinner>
                  <img
                    :src="imageBase64"
                    width="55%"
                    height="50px"
                    v-if="!getCaptchaImagePending"
                  />
                  <!--Captcha Image-->
                </b-col>
                <b-col cols="2" class="cursor-pointer" @click="getCaptchaImage">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="currentColor"
                    class="bi bi-arrow-clockwise"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                    />
                    <path
                      d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"
                    />
                  </svg>
                </b-col>
              </b-row>
              <b-row class="flex-center pb-4">
                <button
                  class="btn ctcPaymentButton"
                  @click="submitBuyerCardInfo()"
                  :class="{
                    'newVersionButtonClass backgroundColorDarkGreen':
                      getVersion === 'v2',
                  }"
                >
                  {{ $translate("checkPayment") }}
                </button>
              </b-row>
            </b-container>
          </transition>
          <!--        /Second Container for (Tether) Show Wallet and Payment Information-->
        </b-col>
      </b-row>
    </transition>
    <!--    <VideoPlayer v-if="showVideo" @closeVideoClickedOutSide="clickedOutSideOfVideo" :videoAddress="videoAddress"/>-->
    <!--    /First Version Caspian-->
  </div>
</template>
<script>
import shetabStepper from "@/components/ShetabStepper";
import { accountToAccountMixin } from "../../mixins/AccountToAccountMixin";

export default {
  name: "AccountToAccount",
  components: {
    // VideoPlayer,
    shetabStepper,
  },
  mixins: [accountToAccountMixin],
};
</script>

<style scoped>
.back-button-position {
  left: 4%;
  top: 4%;
}
.back-button {
  font-size: 0.9rem;
  padding: 4px;
  box-shadow: none;
  padding-inline: 8px;
  border-radius: 10px;
  border: 1px solid var(--black);
  background-color: transparent;
}
.receiver-card-number-input {
  width: fit-content !important;
}
.title-text {
  color: var(--midnight-blue);
  font-weight: bold;
}

.flex-vertical-align {
  display: flex;
  align-items: center;
}
.decline-button {
  width: 100%;
  padding: 5px;
  border-radius: 10px;
  border: 1px solid var(--black);
  background-color: transparent;
}

.go-to-next-button {
  width: 70%;
  height: 30px;
  border: none !important;
  border-radius: 10px;
  background-color: dodgerblue;
  color: white;
}

.ctcPaymentButton {
  background-color: dodgerblue;
  color: white;
  border-radius: 10px;
  width: 80%;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.newVersionButtonClass {
  border-radius: 5px !important;
}

.backgroundColorDarkGreen {
  background-color: #1aaf29 !important;
}

.shetabStepper {
  padding-bottom: 30px;
}

.card-owner-name-text {
  font-size: 1rem;
}

.image-card-details {
  position: absolute;
  margin-top: 7%;
  font-weight: bold;
  font-size: 1.2rem;
  padding-right: 2%;
}

@media only screen and (max-width: 990px) {
  .image-card-details {
    font-size: 2.5rem !important;
    margin-top: 30% !important;
  }

  .card-owner-name-text {
    font-size: 2rem;
  }
}

@media only screen and (max-width: 449px) {
  .image-card-details {
    font-size: 1.5rem !important;
    margin-top: 30% !important;
  }

  .card-owner-name-text {
    font-size: 1.2rem;
  }
}

@media only screen and (max-width: 600px) and (min-width: 450px) {
  .image-card-details {
    font-size: 2.5rem !important;
    margin-top: 30% !important;
  }

  .card-owner-name-text {
    font-size: 2rem;
  }
}
</style>
